import { useEffect } from 'react';
import useSWR from 'swr';
import { SpinnerIconSVG } from 'src/assets/svg';
import container from 'src/container';
import { getOrganizationId } from 'src/domain/user';
import { useSignedInUser } from '../hooks/useSignedInUser';
import { OrganizationForm } from './Admin/components';

const {
    cradle: { munduClient },
} = container;

export const OrganizationSettings = () => {
    const user = useSignedInUser();
    const organizationId = user ? getOrganizationId(user) : undefined;

    const { data } = useSWR(
        organizationId ? ['orginfo', organizationId] : null,
        (_, orgId) => munduClient.getOrganization(orgId),
    );

    useEffect(() => {
        const hash = window.location.hash.replace('#', '');
        if (!hash || !data) return;

        const timer = setTimeout(() => {
            const el = document.getElementById(hash);
            const scrollContainer = document.getElementById('content-view');
            if (el && scrollContainer) {
                scrollContainer.scrollTo({
                    top:
                        el.getBoundingClientRect().top -
                        scrollContainer.getBoundingClientRect().top +
                        scrollContainer.scrollTop,
                    behavior: 'smooth',
                });
            }
            window.history.replaceState(null, '', window.location.pathname);
        }, 100);

        return () => clearTimeout(timer);
    }, [data]);

    if (!organizationId || !data)
        return (
            <div className="grid justify-center">
                <SpinnerIconSVG className="animate-spin h-8 w-8 text-woodyBrown" />
            </div>
        );

    return (
        <OrganizationForm
            organization={data}
            readOnly={Boolean(user?.supportMode)}
            canEditTypeAndLicence={false}
        />
    );
};
